module.exports = __webpack_public_path__ + "static/media/news-16.ab7fc18a.jpg";